import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PublicDataService } from './core/service/public-data.service';
import { VersionCheckService } from './core/service/version-check.service';
import { AuthService } from './core/service/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  // just for reload deployment
  title = 'XFeet-Orthotics.com - Backoffice';

  constructor(
    private translate: TranslateService,
    private authSvc: AuthService,
    private checkSvc: VersionCheckService,
      private publicDataSvc: PublicDataService) {
    this.translate.setFallbackLang('fr');
    if (this.authSvc.isLoggedIn) {
      this.translate.use(this.authSvc.currentMember!.language.code);
    } else {
      const navigatorLang = navigator.language;
      if (navigatorLang.split('-').length) {
        this.translate.use(navigatorLang.split('-')[0]);
      }
    }
  }
  ngOnInit(): void {
    this.publicDataSvc.init();
    this.checkSvc.initVersionCheck('/assets/version.json');
  }

}
